import React from 'react';
import {
    PieChart,
    Pie,
    Cell,
    ResponsiveContainer,
    Tooltip
} from 'recharts';
import './JobsStatusChart.css';

/**
 * JobsStatusChart Component
 * Donut chart showing jobs by status
 */
function JobsStatusChart({ data, totalJobs, loading }) {
    if (loading) {
        return (
            <div className="jobs-status-chart chart-loading">
                <div className="chart-loading-spinner"></div>
            </div>
        );
    }

    if (!data || data.length === 0) {
        return (
            <div className="jobs-status-chart chart-empty">
                <p>No job status data available</p>
            </div>
        );
    }

    const CustomTooltip = ({ active, payload }) => {
        if (active && payload && payload.length) {
            const d = payload[0].payload;
            const percentage = totalJobs > 0
                ? ((d.value / totalJobs) * 100).toFixed(1)
                : 0;
            return (
                <div className="chart-tooltip">
                    <p className="chart-tooltip-label">{d.name}</p>
                    <p className="chart-tooltip-item">
                        <strong>{d.value}</strong> jobs ({percentage}%)
                    </p>
                </div>
            );
        }
        return null;
    };

    return (
        <div className="jobs-status-chart">
            <div className="chart-header">
                <h3 className="chart-title">Jobs by Status</h3>
            </div>

            <div className="donut-chart-container">
                <ResponsiveContainer width="100%" height={220}>
                    <PieChart>
                        <Pie
                            data={data}
                            cx="50%"
                            cy="50%"
                            innerRadius={60}
                            outerRadius={90}
                            paddingAngle={2}
                            dataKey="value"
                        >
                            {data.map((entry, index) => (
                                <Cell
                                    key={`cell-${index}`}
                                    fill={entry.color}
                                    stroke="none"
                                />
                            ))}
                        </Pie>
                        <Tooltip content={<CustomTooltip />} />
                    </PieChart>
                </ResponsiveContainer>

                <div className="donut-center">
                    <span className="donut-total">{totalJobs}</span>
                    <span className="donut-label">Total Jobs</span>
                </div>
            </div>

            {/* Legend */}
            <div className="chart-legend">
                {data.map((item, index) => (
                    <div key={index} className="legend-item">
                        <span
                            className="legend-color"
                            style={{ background: item.color }}
                        ></span>
                        <span className="legend-label">{item.name}</span>
                        <span className="legend-value">{item.value}</span>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default JobsStatusChart;
